/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Paket_GInputs */

const en_tut_paket_g = /** @type {(inputs: Tut_Paket_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This page answers two questions: which plan is in force, and what has already been paid.`)
};

const id_tut_paket_g = /** @type {(inputs: Tut_Paket_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman ini menjawab dua hal: paket apa yang sedang berlaku, dan berapa yang sudah dibayar.`)
};

/**
* | output |
* | --- |
* | "This page answers two questions: which plan is in force, and what has already been paid." |
*
* @param {Tut_Paket_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_paket_g = /** @type {((inputs?: Tut_Paket_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Paket_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_paket_g(inputs)
	return en_tut_paket_g(inputs)
});